// @ts-ignore
const missionId = window?.missionId ?? 0;
export const leaderboardInitialState = {
    filter: {
        missionId: missionId,
        filterPeriod: "alltime",
        leaderboardType: "combined",
        useTeamAverage: false,
        filterExerciseTypes: [],
        version: "",
        cursor: null,
    },
    pageStatus: "loading",
    pages: [],
    version: "",
    availableActivities: [],
    prevCursor: null,
    nextCursor: null,
    distanceUnit: "km",
};
export function leaderboardReducer(state = leaderboardInitialState, action) {
    switch (action.type) {
        case "LOADING_LEADERBOARD":
            return {
                ...state,
                pageStatus: "loading",
            };
        case "ERROR_LEADERBOARD":
            return {
                ...state,
                pageStatus: "error",
            };
        case "GET_LEADERBOARD":
            if (!action.payload) {
                return { ...state };
            }
            return {
                ...state,
                filter: action.params ?? state.filter,
                pages: [action.payload.page],
                pageStatus: "success",
                version: action.payload.version,
                availableActivities: action.payload.availableActivities,
                distanceUnit: action.payload.distanceUnit,
                maxRank: action.payload.maxRank,
                nextCursor: action.payload.nextCursor,
                prevCursor: action.payload.prevCursor,
            };
        case "UPDATE_LEADERBOARD_START":
            if (!action.payload) {
                return { ...state };
            }
            return {
                ...state,
                pages: [action.payload.page, ...state.pages],
                pageStatus: "success",
                prevCursor: action.payload.prevCursor,
            };
        case "UPDATE_LEADERBOARD_END":
            if (!action.payload) {
                return { ...state };
            }
            return {
                ...state,
                pages: [...state.pages, action.payload.page],
                pageStatus: "success",
                nextCursor: action.payload.nextCursor,
            };
        case "GET_LEADERBOARD_LOOKUP":
            if (!action.payload) {
                return { ...state };
            }
            const teamId = action.params?.id;
            let newState = state;
            // Add team members to leaderboard participant (team)
            for (let i = 0; i < state.pages.length; i++) {
                for (let j = 0; j < state.pages[i].length; j++) {
                    if (state.pages[i][j].id === teamId) {
                        newState.pages[i][j].team = {
                            maxRank: action.payload.maxRank,
                            prevCursor: action.payload.prevCursor,
                            nextCursor: action.payload.nextCursor,
                            pages: [action.payload.page.teamMembers],
                        };
                        break;
                    }
                }
            }
            return { ...newState };
        case "UPDATE_LEADERBOARD_LOOKUP_START":
            if (!action.payload) {
                return { ...state };
            }
            const teamIdStart = action.params?.id;
            let newStateStart = state;
            // Add team members to leaderboard participant (team)
            for (let i = 0; i < state.pages.length; i++) {
                for (let j = 0; j < state.pages[i].length; j++) {
                    if (state.pages[i][j].id === teamIdStart) {
                        const nextPages = state.pages[i][j].team?.pages ?? [];
                        newStateStart.pages[i][j].team = {
                            maxRank: action.payload.maxRank,
                            prevCursor: action.payload.prevCursor,
                            nextCursor: newStateStart.pages[i][j].team.nextCursor,
                            pages: [
                                action.payload.page.teamMembers,
                                ...nextPages,
                            ],
                        };
                        break;
                    }
                }
            }
            return { ...newStateStart };
        case "UPDATE_LEADERBOARD_LOOKUP_END":
            if (!action.payload) {
                return { ...state };
            }
            const teamIdEnd = action.params?.id;
            let newStateEnd = state;
            // Add team members to leaderboard participant (team)
            for (let i = 0; i < state.pages.length; i++) {
                for (let j = 0; j < state.pages[i].length; j++) {
                    if (state.pages[i][j].id === teamIdEnd) {
                        const prevPages = state.pages[i][j].team?.pages ?? [];
                        newStateEnd.pages[i][j].team = {
                            maxRank: action.payload.maxRank,
                            prevCursor: newStateEnd.pages[i][j].team.prevCursor,
                            nextCursor: action.payload.nextCursor,
                            pages: [
                                ...prevPages,
                                action.payload.page.teamMembers,
                            ],
                        };
                        break;
                    }
                }
            }
            return { ...newStateEnd };
        default:
            return state;
    }
}
